import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReturnDetailScreen } from '@/features/sales-returns/return-detail-screen'
import { hasGrant } from '@/lib/me'

/** `.index` keeps this a sibling under `returns.tsx`'s own Outlet. */
export const Route = createFileRoute('/_authenticated/sales/returns/$returnId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'customer_return.view')) {
      throw redirect({ to: '/sales/returns' })
    }
  },
  component: CustomerReturnDetailRoute,
})

function CustomerReturnDetailRoute() {
  const { returnId } = Route.useParams()

  return <ReturnDetailScreen returnId={returnId} />
}
